import React, { useState } from 'react';
import './ChatMessage.css';
import ComponentCard from './ComponentCard';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ChatMessage = ({ message, isUser, onDownloadFile }) => {
    const alignmentClass = isUser ? 'user-align' : 'system-align';
    const [showThought, setShowThought] = useState(false);

    const extractThought = (text) => {
        const match = text.match(/<thought>([\s\S]*?)<\/thought>/i);
        const thought = match ? match[1].trim() : null;
        const rest = text.replace(/<thought>[\s\S]*?<\/thought>/gi, "");
        return { thought, rest };
    };

    const extractGeneratedFileId = (text) => {
        const match = text.match(/PDF_GENERATED:(\d+)/);
        return match ? parseInt(match[1], 10) : null;
    };

    const getCleanText = (text) => {
        return text.replace(/\[STEP:.*?\]/g, "").replace(/PDF_GENERATED:\d+/g, "").trim();
    };

    let thought = null;
    let displayText;
    let generatedFileId = null;
    if (isUser) {
        displayText = message.text;
    } else {
        const parsed = extractThought(message.text);
        thought = parsed.thought;
        generatedFileId = extractGeneratedFileId(parsed.rest);
        displayText = getCleanText(parsed.rest);
    }

    return (
        <div className={`message-wrapper ${alignmentClass}`}>
            <div className={`message-bubble ${isUser ? 'bubble-user' : 'bubble-system'}`}>
                {/*<p className="message-text">{message.text}</p>*/}
                {thought && (
                    <div className={`thought-block ${showThought ? 'open' : ''}`}>
                        <button
                            type="button"
                            className="thought-summary"
                            aria-expanded={showThought}
                            onClick={() => setShowThought(v => !v)}
                        >
                            Ragionamento
                        </button>
                        <div className="thought-collapsible">
                            <div className="thought-content">
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {thought}
                                </ReactMarkdown>
                            </div>
                        </div>
                    </div>
                )}
                <div className="markdown-content message-text">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {displayText}
                        </ReactMarkdown>
                </div>

                {generatedFileId != null && (
                    <div className="message-attachments">
                        <button
                            type="button"
                            className="attachment-pill attachment-download"
                            onClick={() => onDownloadFile && onDownloadFile(generatedFileId)}
                        >
                            <span className="attachment-icon">📄</span>
                            <span className="attachment-name">Scarica il documento</span>
                            <span className="attachment-download-icon">⬇</span>
                        </button>
                    </div>
                )}
                
                {message.component && (
                    <ComponentCard componentData={message.component} />
                )}
                
                {message.files && message.files.length > 0 && (
                    <div className="message-attachments">
                        {message.files.map((file, index) => (
                            <div key={index} className="attachment-pill">
                                <span className="attachment-icon">📄</span>
                                <span className="attachment-name">{file.name}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatMessage;